module.exports = __webpack_public_path__ + "img/logo.bd130f6a.png";